export default {
  methods: {
    runningOnProduction () {
      return process.env.NODE_ENV === 'production'
    }
  }
}
